const GLOBAL_NAMESPACE = "flexTeam";
const DEFAULT_OPTIONS = {
  serializer: JSON.stringify,
  deserializer: JSON.parse
};
class BaseStorage {
  constructor(storage, options) {
    this.storage = storage;
    this.clear = () => {
      try {
        const length = this.storage.length;
        for (let i = 0; i < length; i++) {
          const key = this.storage.key(i);
          if (this.isNamespacedKey(key)) {
            this.storage.removeItem(key);
          }
        }
      } catch {
        return;
      }
    };
    this.getItem = (key) => {
      try {
        const realKey = this.toNamespacedKey(key);
        const serializedPayload = this.storage.getItem(realKey);
        if (serializedPayload === null) {
          return null;
        }
        return this.options.deserializer(serializedPayload);
      } catch {
        this.removeItem(key);
        return null;
      }
    };
    this.removeItem = (key) => {
      try {
        const realKey = this.toNamespacedKey(key);
        this.storage.removeItem(realKey);
      } catch {
      }
    };
    this.setItem = (key, value) => {
      try {
        const serializedPayload = this.options.serializer(value);
        const realKey = this.toNamespacedKey(key);
        this.storage.setItem(realKey, serializedPayload);
      } catch {
      }
    };
    this.options = {
      ...DEFAULT_OPTIONS,
      ...options
    };
  }
  toNamespacedKey(key) {
    return `${GLOBAL_NAMESPACE}.${this.options.namespace}.${key}`;
  }
  isNamespacedKey(key) {
    return !!key && key.startsWith(`${GLOBAL_NAMESPACE}.${this.options.namespace}.`);
  }
  get isAvailable() {
    if (!this.storage) {
      return false;
    }
    const testKey = this.toNamespacedKey("__test__");
    try {
      this.storage.setItem(testKey, "");
      this.storage.removeItem(testKey);
      return true;
    } catch {
      return false;
    }
  }
  /**
   * @deprecated don't use this method since it's not namespace safe
   */
  get length() {
    try {
      return this.storage.length;
    } catch {
      return 0;
    }
  }
  /**
   * @deprecated don't use this method since it's not namespace safe
   */
  key(index) {
    try {
      return this.storage.key(index);
    } catch {
      return null;
    }
  }
}

export { BaseStorage };
//# sourceMappingURL=index.mjs.map
